/*

I move this here bc Server needs it, and importing Price.jsx
prompted the import of Price.less

you can't do that on the Server, it has no webpack & less-loader

*/

export const emptyPrice = {
  general: 0, 
  ageAware: false,       
  perGroup: false,
  agePrices: [],

  kids: 0,              // old format
  kidsDifferent: false, // old format
}

function _priceType(p) {
  const a = p.agePrices && p.agePrices.length > 0
  if (p.kidsDifferent) return "K"
}

export function normalizePrice(p) {
  if (p.kidsDifferent && !p.perGroup) {
    return {
      ...p,
      kids: null,
      kidsDifferent: false,
      ageAware: true,
      agePrices: [{ 
        age: 16, 
        price: p.kids || 0 
      }]
    }
  }
  else if (p.ageAware) {
    return {
      ...p,
      agePrices: p.agePrices || []
    }
  }
  else return p
}